export default __webpack_public_path__ + "img/img_christine-1b9bd4e2f8290d07a1ecbdab354df150.jpg";